import { Component, OnInit, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ConversationListService } from 'src/app/services/conversation-list.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'info-test-page',
  templateUrl: './info-test-page.component.html',
  styleUrls: ['./info-test-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class InfoTestPageComponent implements OnInit {
  @Input() test: string = '';
  loggedInUser: string;

  constructor(
    public conversationListService: ConversationListService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    var sub = new Subscription();
    sub.add(
      this.conversationListService.ready$.subscribe(() => {
        this.loggedInUser = this.conversationListService.loggedInUserId;
        this.cdr.markForCheck();
        sub.unsubscribe();
      })
    );
  }
}
